
import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import {
	Redirect,
	Switch
} from 'react-router-dom';
import { withRouter } from "react-router";

import { connect } from 'react-redux';
import { CurrentStepSetAction, setListDealersFiltred } from '../../actions/action';
import { headTitleTag } from '../../helpers/functions';

import { withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import MarkerClusterer from "react-google-maps/lib/components/addons/MarkerClusterer";

import BodyClassName from 'react-body-classname';
import DealerBlock from '../DealerBlock/DealerBlock';
import DealerBlockLoader from '../DealerBlock/dealerBlockLoader';
import HappyHoureTitle from '../Titles/HappyHoureTitle';
import CONSTANTS from '../../constants.js';
import './pagemap.css';
/*import markerIconAP from '../../images/AP/pin-peugeot-map.svg';
import markerIconActiveAP from '../../images/AP/pin-peugeot-map-active.svg';*/


import markerIconAP from '../../images/AP/pin-peugeot-map.png';
import markerIconActiveAP from '../../images/AP/pin-peugeot-hover.png';
import clusterIconAP from '../../images/AP/ap-pin-number.png';
/*import markerIconAC from '../../images/AC/citroen-pin.svg';
import markerIconActiveAC from '../../images/AC/citroen-pin-hover.svg';*/

import markerIconAC from '../../images/AC/pin-ac-defaut.svg';
import markerIconActiveAC from '../../images/AC/pin-ac-hover.svg';
import clusterIconAC from '../../images/AC/ac-pin-number.svg';

import markerIconDS from '../../images/DS/ds-pin-Small.png';
import markerIconActiveDS from '../../images/DS/ds-pin-Big-Hover.png';
import clusterIconDS from '../../images/DS/ds-pin-number.svg';

import markerIconOV from '../../images/OV/pin-ov-defaut.png'
import markerIconActiveOV from '../../images/OV/pin-ov-hover.png'
import clusterIconOV from '../../images/OV/ov-pin-number.png'

import fetchApiData from '../apiHandlers/fetchApiData'
import ShowMoreButton from '../buttons/showMoreButton'
import { isEqual } from 'lodash'


if (window.siteConfig.currentBrand == 'P') {
	var _marker = new Object({
		icon: markerIconAP,
		iconActive: markerIconActiveAP,
		iconCluster: clusterIconAP,
		size: (window.google.maps ? new window.google.maps.Size(80, 80) : false),
		scaledSize: (window.google.maps ? new window.google.maps.Size(80, 80) : false),
		origin: (window.google.maps ? new window.google.maps.Point(0, 0) : false)
	});
}

if (window.siteConfig.currentBrand == 'C') {
	var _marker = new Object({
		icon: markerIconAC,
		iconActive: markerIconActiveAC,
		iconCluster: clusterIconAC,
		size: (window.google.maps ? new window.google.maps.Size(91, 98) : false),
		scaledSize: (window.google.maps ? new window.google.maps.Size(91, 98) : false),
		origin: (window.google.maps ? new window.google.maps.Point(0, 0) : false)
	});

}
if (window.siteConfig.currentBrand == 'D') {
	_marker = new Object({
		icon: markerIconDS,
		iconActive: markerIconActiveDS,
		iconCluster: clusterIconDS,
		size: (window.google.maps ? new window.google.maps.Size(50, 50) : false),
		scaledSize: (window.google.maps ? new window.google.maps.Size(50, 50) : false),
		origin: (window.google.maps ? new window.google.maps.Point(0, 0) : false)
	});

}

if (window.siteConfig.currentBrand == 'V') {
	_marker = new Object({
		icon: markerIconOV,
		iconActive: markerIconActiveOV,
		iconCluster: clusterIconOV,
		size: (window.google.maps ? new window.google.maps.Size(44, 63) : false),
		scaledSize: (window.google.maps ? new window.google.maps.Size(44, 63) : false),
		origin: (window.google.maps ? new window.google.maps.Point(0, 0) : false)
	})
}





var labels = window.labels;
const google = window.google;
var Gmap;

const mapStateToProps = state => state;
const mapDispatchToProps = { CurrentStepSetAction, setListDealersFiltred };

const MyMapComponent = withGoogleMap(
	(props) =>
		<GoogleMap
			defaultZoom={12}
			ref={props.onMapMounted}
			defaultCenter={props.attDefaultCenter}
			options={props.attOptions}

			{...props}
		>
			<MarkerClusterer
				averageCenter
				gridSize={80}
				maxZoom={9}
				styles={(window.siteConfig.currentBrand == 'P' ? [{ textColor: '#fff', fontFamily: 'Peugeot', textSize: 18, height: 120, url: _marker.iconCluster, width: 120, left: -1, lineHeight: 90 }]
					: (window.siteConfig.currentBrand == 'C' ? [{ textColor: '#fff', fontFamily: 'Ubuntu', textSize: 20, height: 53, url: _marker.iconCluster, width: 53 }]
						: (window.siteConfig.currentBrand == 'D' ? [{ textColor: '#fff', fontFamily: 'Roboto', textSize: 20, height: 53, url: _marker.iconCluster, width: 53 }]
							: [{ textColor: '#000', fontFamily: 'Opel', textSize: 14, height: 42, url: _marker.iconCluster, width: 42 }])))}
			>
				{props.children}
			</MarkerClusterer>
		</GoogleMap>
)

class PageMap extends PureComponent {
	_isMounted = false;
	constructor(props) {
		super(props);
		this.getDistanceBetweenPlaces = this.getDistanceBetweenPlaces.bind(this);
		this.showMore = this.showMore.bind(this);
		this.markerIsHover = this.markerIsHover.bind(this);
		this.dealerIsHover = this.dealerIsHover.bind(this);
		this.markerNotHover = this.markerNotHover.bind(this);
		this.setOpendDealerBlock = this.setOpendDealerBlock.bind(this);
		this.handleScrollToElement = this.handleScrollToElement.bind(this);
		this.setLatLangAccordingToCityInURL = this.setLatLangAccordingToCityInURL.bind(this);
		this.state = {
			data: [],
			dealersFiltred: this.props.store.dealersFiltred,
			selectedData: [],
			isLoading: false,
			errorRedirect: false,
			pagination: 9,
			stickyMap: null,
			openDealerBlock: null,
			map: {
				adress: "",
				lat: 0,
				lng: 0,
			}
		};

	}
	setLatLangAccordingToCityInURL(props = this.props) {
		const geocoder = new google.maps.Geocoder();
		return new Promise((resolve, reject) => {
			geocoder.geocode({
				address: props.match.params.adress,
				componentRestrictions: {
					country: window.siteConfig.currentCountry
				}
			},
				function (results, status) {
					if (status === 'OK') {
						if (results[0]) {
							this.setState({
								map: {
									adress: results[0].formatted_address,
									lat: results[0].geometry.location.lat(),
									lng: results[0].geometry.location.lng(),
								}
							});
							resolve(results[0].formatted_address);
						} else {
							console.log('No results found');
						}
					} else {
						this.setState({ errorRedirect: true });
						console.error(new Error('Geocoder failed due to: ' + status));


					}
				}.bind(this));
		});

	}
	componentDidMount() {
		this._isMounted = true;
		this.props.CurrentStepSetAction(2);
		this.setState({ isLoading: true });


		this.setLatLangAccordingToCityInURL().then(() => {



			const listDealers = new fetchApiData();
			listDealers.getListDealers().then(
				data => {
					if (this._isMounted) {
						this.setState({
							isLoading: false,
							data: data.d,
						});
						this.props.store.filterDealersBy.length > 0 ? this.filterDealers() : this.setState({ dealersFiltred: data.d })
						/*const place = ( typeof this.props.match.params.adress != 'undefined' ? 
							this.props.match.params.adress.split(';') : '0;0'.split(';') );
					
					this.setState({map:{
							lat: place[0],
							lng:place[1]
							 }});  */
						this.setState({
							selectedData: Object.values(this.getDistanceBetweenPlaces(this.props)).sort(function (a, b) {
								return a.Distance - b.Distance;
							}).slice(0, 10)
						});

					}
				})
				.catch(error => {
					this.setState({
						error,
						isLoading: false
					})
					console.error('fail', error);
				});


		});


		// On scroll get map sticked to top 
		// adding class 'sticky-map to container'
		window.addEventListener('scroll', (event) => {
			//old footer <900
			if (CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && window.pageYOffset > 250 && window.pageYOffset < document.body.offsetHeight - 600 && this.state.selectedData.length > 1) {
				this.setState({ stickyMap: 'sticky-map' });
			} 
			else if (CONSTANTS.SITE_INFO.BRAND_CODE === "C" && window.pageYOffset > 500 && window.pageYOffset < document.body.offsetHeight - 850) {
				this.setState({ stickyMap: 'sticky-map' });
			}
			else if (CONSTANTS.SITE_INFO.BRAND_CODE === "C" && window.scrollY > document.body.offsetHeight - 850){
				this.setState({ stickyMap: 'not-sticky-map' });
			} 
			else {
				this.setState({ stickyMap: '' });
			}

		});

		// GA Start
		window.dataLayer.push({
			'event': 'updatevirtualpath',
			'brand': window.siteConfig['brandGTM'],
			'virtualPageURL': "/dealer-locator/appointment-schedule-search",
			'pageName': window.siteConfig['pageName'],
			'language': window.siteConfig['language'],
			'country': window.siteConfig['currentCountry'],
			'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
			'siteTypeLevel2': "appointement",
			'siteOwner': "central",
			'siteTarget': "B2C",
			'siteFamily': "after-sales",
			'pageCategory': "dealer locator page",
		});

		// GA Ends
	}
	//filter the dealers with the user choice (services selected in filter)

	filterDealers = () => {
		let dealersFiltred = this.props.store.filterDealersBy.length > 0
			? this.state.data.filter(dealer =>
				this.props.store.filterDealersBy.every(elemnt => dealer.ListeIdSP.includes(elemnt)))
			: this.state.data
		this.setState({ dealersFiltred: dealersFiltred })
		this.props.setListDealersFiltred(dealersFiltred)
	}

	componentWillUnmount() {
		this._isMounted = false;
	}
	//call the filter methode if the filter by changed 
	componentDidUpdate = (prevProps) => {
		if (!isEqual(this.props.store.filterDealersBy, prevProps.store.filterDealersBy)) {
			this.filterDealers();
		}
	}


	componentWillReceiveProps(nextProps) {
		this.setLatLangAccordingToCityInURL(nextProps).then(() => {
			this.setState({
				selectedData: Object.values(this.getDistanceBetweenPlaces(nextProps)).slice(0, 10)
			});
			if (Gmap != null)
				Gmap.panTo(new google.maps.LatLng(this.state.map.lat, this.state.map.lng));
		});


	}

	getDistanceBetweenPlaces(urlProps = this.props) {
		//let place = [this.state.map.lat,this.state.map.lng];
		let place = [this.props.store.selectedLat, this.props.store.selectedLong];
		let dealers = Object.assign({}, this.state.dealersFiltred);
		dealers = Object.values(dealers).map(function (dealer) {
			dealer.IsHover = false;
			const currentAdress = new google.maps.LatLng(place[0], place[1]);
			const dealerLocation = new google.maps.LatLng(dealer.Latitude, dealer.Longitude);
			dealer.Distance = (google.maps.geometry.spherical.computeDistanceBetween(currentAdress, dealerLocation) / 1000).toFixed(2);
			return dealer;
		});
		this.setState({
			dealersFiltred: dealers.sort(function (a, b) {
				return a.Distance - b.Distance;
			})
		});
		return dealers.sort(function (a, b) {
			return a.Distance - b.Distance;
		});

	}
	showMore() {
		this.setState({
			selectedData: this.state.dealersFiltred.slice(0, this.state.pagination + 10),
			pagination: this.state.pagination + 10,


		})
	}

	markerIsHover(id, scrollToIt = false) {
		let dealers = Object.assign({}, this.state.selectedData);
		let selectedDealer = [];
		for (var i = 0; i < Object.keys(dealers).length; i++) {

			if (dealers[i].DealerId === id) {
				dealers[i].IsHover = true;
				selectedDealer = dealers[i];
			}
		}

		this.setState({
			selectedData: Object.values(dealers),

		});
		// Center the pin .
		/* Gmap.panTo(new google.maps.LatLng(
							Number(selectedDealer.Latitude),
							Number(selectedDealer.Longitude) 
							)); */
		// Focus on dealer on marker hover
		if (scrollToIt) {
			const d = ReactDOM.findDOMNode(this.refs['id' + id])
			d.focus();
			window.scrollTo(0, d.offsetTop);

		}


	}
	dealerIsHover(id) {
		let dealers = Object.assign({}, this.state.selectedData);
		let selectedDealer = [];
		for (var i = 0; i < Object.keys(dealers).length; i++) {

			if (dealers[i].DealerId === id) {
				dealers[i].IsHover = true;
				selectedDealer = dealers[i];
			}
		}

		this.setState({
			selectedData: Object.values(dealers),
		});
		Gmap.panTo(new google.maps.LatLng(
			Number(selectedDealer.Latitude),
			Number(selectedDealer.Longitude)
		));



	}
	markerNotHover() {
		let dealers = Object.assign({}, this.state.selectedData);
		for (var i = 0; i < Object.keys(dealers).length; i++) {
			dealers[i].IsHover = false;
		}

		this.setState({ selectedData: Object.values(dealers) });

	}

	handleScrollToElement(idDealer) {
		const d = ReactDOM.findDOMNode(this.refs['id' + idDealer])
		if (d) {
			d.focus();
			window.scrollTo(0, d.offsetTop + 250);
		}

	}
	setOpendDealerBlock(idDealer) {
		this.setState({ openDealerBlock: idDealer });
		this.handleScrollToElement(idDealer);
	}

	handleMapMounted(map) {
		Gmap = map;
	}

	render() {
		const SEO_TITLE = (window.siteConfig.v2multicreneaux != undefined ? window.siteConfig.v2multicreneaux.Title : '');
		const SEO_DESC = (window.siteConfig.v2multicreneaux != undefined ? window.siteConfig.v2multicreneaux.MetaDescription : '');
		const happyHoureMessage = (window.innerWidth <= 800 ? CONSTANTS.LABELS.multislots_happy_hours_mobile : CONSTANTS.LABELS.multislots_happy_hours_desktop);
		const isHappuHoureMessageEnabled = (happyHoureMessage.length > 2 ? true : false);
		return (
			<div className="content-wrapper container-full-content">
				{
					headTitleTag(SEO_TITLE.replace('[nom_marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()).replace('[nom_ville]', this.state.map.adress.toUpperCase()),
						SEO_DESC.replace('[nom_marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()).replace('[nom_ville]', this.state.map.adress.toUpperCase()))
				}

				{
					this.state.errorRedirect &&
					<Switch>
						<Redirect to={`/404`} />
					</Switch>}


				<BodyClassName className="page--dealers" />
				{CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && <p tabIndex="0" className="content-headline"> {CONSTANTS.LABELS.multislots_select_slot} </p>}
				<div className="map_page--details">
					{isHappuHoureMessageEnabled && CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && <HappyHoureTitle />}
					<div className="dealers-listing half-block">
						<div className="dealers-block-container">
							{!this.state.isLoading && this.state.selectedData && this.state.selectedData.map(function (item, key) {
								return (<DealerBlock
									dealerMouseOver={this.dealerIsHover}
									dealerMouseOut={this.markerNotHover}
									dealerName={item.Name}
									dealerDistance={false}
									dealerID={item.DealerId}
									dealerGeoId={item.GeoId}
									dealerAdress={item.Address}
									SelfReception={item.SelfReception}
									dealerCity={item.City}
									dealerZipCode={item.ZipCode}
									dealerPremServices={item.ListeIdSP}
									listPremiumServices={this.props.store.listPremiumServices}
									dealerLCV={item.LCV}
									dealerPC={item.PC}
									position={{ lat: Number(item.Latitude), lng: Number(item.Longitude) }}
									ref={'id' + item.DealerId}
									key={item.DealerId}
									opendDealerBlockID={this.setOpendDealerBlock}
									dealerOpen={(this.state.openDealerBlock == item.DealerId ? "f" : "false")}
								/>)


							}.bind(this)
							)}
							{this.state.isLoading && <DealerBlockLoader />}
							<ShowMoreButton onClick={this.showMore} />
						</div>
					</div>

					<div className="map-block half-block" style={{ top: (!isHappuHoureMessageEnabled ? "0px" : "") }}>
						<MyMapComponent
							loadingElement={<div style={{ height: `100%` }} />}
							containerElement={<div style={{ height: `700px` }} className={'map-container ' + this.state.stickyMap} />}
							mapElement={<div style={{ height: `100%` }} />}
							attDefaultCenter={{ lat: Number(this.state.map.lat), lng: Number(this.state.map.lng) }}
							defaultCenter={{ lat: Number(this.state.map.lat), lng: Number(this.state.map.lng) }}
							attOptions={{ mapTypeControl: false, streetViewControl: false, }}
							onMapMounted={this.handleMapMounted}
						>
							{this.state.selectedData.map(function (item, key) {
								return <Marker
									position={{ lat: Number(item.Latitude), lng: Number(item.Longitude) }}
									title={item.Name}
									options={{ optimized: false }}
									alt={item.Name}
									icon={(item.IsHover ? new Object({
										url: _marker.iconActive,
										size: _marker.size,
										scaledSize: _marker.scaledSize,
										origin: _marker.origin
									})
										:
										new Object({
											url: _marker.icon,
											size: _marker.size,
											scaledSize: _marker.scaledSize,
											origin: _marker.origin
										}))}
									onMouseOver={window.siteConfig.currentBrand != 'D' ?
										(marker) => { this.markerIsHover(item.DealerId) }
										: ''
									}
									onMouseOut={(marker) =>
										this.markerNotHover()
									}
									onClick={(marker) => {
										this.handleScrollToElement(item.DealerId);
										this.markerIsHover(item.DealerId, true);
									}
									}
									key={item.DealerId} />
							}.bind(this)
							)}

						</MyMapComponent>
					</div>
				</div>
			</div>
		);
	}
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageMap));
